import { useState } from 'react';

import { MouseTooltip } from 'components/ui/MouseTooltip';
import type { YardGateEntry } from '../../adapter';

interface ObservationCellProps {
  entry: YardGateEntry;
}

export const ObservationCell = ({ entry }: ObservationCellProps) => {
  const [hover, setHover] = useState<{ x: number; y: number } | null>(null);
  const canShowTooltip =
    entry.status !== 'CANCELLED' && entry.status !== 'NO_SHOW';

  return (
    <>
      <span
        className="inline-flex max-w-[220px] items-center gap-1"
        onMouseMove={(event) =>
          setHover({ x: event.clientX, y: event.clientY })
        }
        onMouseLeave={() => setHover(null)}
      >
        <span className="truncate">{entry.observation || '—'}</span>
      </span>
      {hover && canShowTooltip && entry.observation ? (
        <MouseTooltip
          x={hover.x}
          y={hover.y}
          title="Observações"
          description={entry.observation}
        />
      ) : null}
    </>
  );
};
